import React from 'react';
import {
  FinalCTA,
  FinalCTAContent,
  FinalCTAActions,
  //   PrimaryLink,
  //   SecondaryLink,
} from './FinalCTA.styles';
import { useNavigate } from 'react-router-dom';
import PrimaryButton from '../../../Components/Buttons/PrimaryButton/PrimaryButton.component';
import SecondaryButton from '../../../Components/Buttons/SecondaryButton/SecondaryButton.component';
const FinalCTAC = () => {
  const navigate = useNavigate();
  return (
    <FinalCTA>
      <FinalCTAContent>
        <p className="eyebrowHeader">Ready to Get Started?</p>

        <h2>Bring Your Company&apos;s Training Together</h2>

        <p>
          Create a company account to assign safety training, manage employees,
          track progress, and keep training records easier to access.
        </p>
      </FinalCTAContent>

      <FinalCTAActions>
        <PrimaryButton
          functionName={() => navigate('/company-signup')}
          span="Register Your Company"
        />
        <SecondaryButton
          functionName={() => navigate('/training')}
          span="Explore Training"
        />
      </FinalCTAActions>
    </FinalCTA>
  );
};

export default FinalCTAC;
